import React from "react";
import { cx } from "utils/join-classnames";
import styles from "./LoaderContainer.module.scss";

interface Props {
    className?: string;
    message?: string;
    theme?: "light" | "dark";
}
const LoaderContainer: React.FC<Props> = ({
    className,
    message,
    theme = "light",
}) => (
    <div
        className={cx(
            styles.container,
            theme === "dark" ? styles.theme__dark : null,
            className,
        )}
    >
        <div className={styles.message}>{message}</div>
    </div>
);

export default LoaderContainer;
